import { Constants } from "../constants"
import { ApiError, ApiService } from "./api.service"
import { BookingOption } from "./booking.service"
import moment from 'moment'

class Arrival {
    constructor(arrival) {
        this.bookingId = arrival ? arrival.id : undefined
        this.name = arrival ? arrival.name : undefined
        this.option = arrival ? arrival.option || new BookingOption() : new BookingOption()
        this.startDate = arrival ? arrival.startDate :  undefined
        this.endDate = arrival ? arrival.endDate : undefined
        this.licensePlate = arrival ? arrival.licensePlate : undefined
        this.vehicleArrivalDate = arrival ? arrival.vehicleArrivalDate : undefined
        this.vehicleDepatureDate = arrival ? arrival.vehicleDepatureDate : undefined
        this.dockArrivalDate = arrival ? arrival.dockArrivalDate: undefined
        this.dockDepartureDate = arrival ? arrival.dockDepartureDate: undefined
        this.startHandlingDate = arrival ? arrival.startHandlingDate : undefined
        this.stopHandlingDate = arrival ? arrival.stopHandlingDate : undefined
        this.spots = arrival ? arrival.spots : undefined
    }

    formatTimeslots() {
        const startTime = moment(this.startDate).format('HH:mm')
        const endTime = moment(this.endDate).format('HH:mm')
        return `${startTime} - ${endTime}`
    }

    progress() {
        const startTime = moment(this.startDate)
        const expiredMinutes = moment().diff(startTime, 'minutes') - this.delayedMinutes()

        const progress = (expiredMinutes / this.totalMinutes()) * 100
        const offset = 100 - this.delayedProgress()

        return (progress > offset ? offset : progress)
    }

    delayedProgress() {
        return (this.delayedMinutes() / this.totalMinutes()) * 100
    }

    totalMinutes() {
        var startTime = moment(this.startDate)
        var endTime = moment(this.endDate)
        return endTime.diff(startTime, 'minutes')
    }

    delayedMinutes() {
        const startTime = moment(this.startDate)
        const arrivedTime = moment(this.vehicleArrivalDate)
        const arrivedDiff = arrivedTime.diff(startTime, 'minutes')
        return this.vehicleArrivalDate ? arrivedDiff < 0 ? 0 : arrivedDiff : 0
    }
}

class Arrivals {
    constructor(arrivals) {
        this.expected = arrivals ? arrivals.expected.map(o => new Arrival(o)) : undefined
        this.arrived = arrivals ? arrivals.arrived.map(o => new Arrival(o)) : undefined
        this.onDock = arrivals ? arrivals.onDock.map(o => new Arrival(o)) : undefined
        this.offDock = arrivals ? arrivals.arrived.map((arrival) => {
            if( arrival.dockDepartureDate !== null && arrival.vehicleDepatureDate == null) {
                return new Arrival(arrival)
            }
        }) : undefined
        this.delayed = arrivals ? arrivals.delayed.map(o => new Arrival(o)) : undefined
        this.handling = arrivals ? arrivals.handling?.map(o => new Arrival(o)) : undefined
        this.departed = arrivals ? arrivals.departed?.map(o => new Arrival(o)) : undefined
    }
}

const ArrivalService = {

    getArrivals: async function(locationId, startDate) {
        try {
            startDate = moment(startDate).startOf('day').toISOString()
            const endDate = moment(startDate).add(1, 'day').startOf('day').toISOString()

            const endpoint = `${Constants.ENDPOINT_ARRIVALS}?locationid=${locationId}&startdate=${startDate}&enddate=${endDate}`
            const response = await ApiService.get(endpoint)
            return response.data
        }catch(error) {
            throw new ApiError(error)
        }
    }

}

export { ArrivalService, Arrival, Arrivals }
